import axios from "axios";

const getUnitSalesForTour = async (token, tourId) => {
  const path = `${process.env.REACT_APP_BACKEND_API_URL}/tours/${tourId}/units`;

  try {
    const response = await axios.get(path, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
    // console.log(response);
    return response;
  } catch (error) {
    console.log(error.response);
    return error.response;
  } 
};

export default getUnitSalesForTour;